import { compose, defaultTo, prop } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';

import { NAME } from './constants';

const getRoot = prop(NAME);

// renamed from getGuarantorsData
export const getRegions = compose(prop('regions'), getRoot);
export const getHoveredRegionId = compose(prop('hoveredRegionId'), getRoot);

export const getHoveredRegion = createSelector(getRegions, getHoveredRegionId, (regions, id) => {
	const region = regions.find((region) => region.id === id);
	return defaultTo(EMPTY_VALUES.OBJECT)(region);
});
